import { useEffect, useState } from 'react'
import { useAccessToken, useDistributionPrincipal } from '@dss/auth'
import { getDistributorContacts, type DistributorContacts as Contacts } from '@dss/api-client'
import { Button } from '@dss/design-system'
import { api } from '../lib/api'
import { usePortalSession } from '../features/invitations/usePortalMembership'
import './distributor-contacts.css'

export function DistributorContacts() {
  const principal = useDistributionPrincipal()
  const token = useAccessToken()
  const session = usePortalSession()
  if (!token || !principal || principal.isPlatformAdmin || session.isError || session.isPending || session.data?.state !== 'ACTIVE'
    || !['CLIENT_OWNER', 'CLIENT_EMPLOYEE'].includes(session.data.role)) return null
  return <ContactsDisclosure key={`${principal.distributorId}:${principal.userId}`} token={token} />
}

function ContactsDisclosure({ token }: { token: string }) {
  const [open, setOpen] = useState(false)
  return <details className="distributor-contacts" onToggle={(event) => setOpen(event.currentTarget.open)}>
    <summary>Связаться с дистрибьютором</summary>
    {open && <ContactsBody token={token} />}
  </details>
}

function ContactsBody({ token }: { token: string }) {
  const [attempt, setAttempt] = useState(0)
  const [state, setState] = useState<{ token: string; data?: Contacts; error?: boolean } | null>(null)
  useEffect(() => {
    const controller = new AbortController()
    let current = true
    setState(null)
    void getDistributorContacts(api, token, controller.signal).then((data) => {
      if (current) setState({ token, data })
    }, () => { if (current) setState({ token, error: true }) })
    return () => { current = false; controller.abort() }
  }, [token, attempt])
  const loaded = state?.token === token ? state : null
  if (!loaded) return <p role="status">Загружаем контакты…</p>
  if (loaded.error || !loaded.data) return <div>
    <p role="alert">Не удалось получить актуальные контакты.</p>
    <Button onClick={() => { setState(null); setAttempt((value) => value + 1) }}>Повторить загрузку контактов</Button>
  </div>
  const data = loaded.data
  const phone = data.phone && /^[+0-9 ()-]{5,40}$/u.test(data.phone)
    && /^\+?[0-9]{5,15}$/u.test(data.phone.replace(/[ ()-]/gu, '')) && !/[\r\n]/u.test(data.phone) ? data.phone : null
  const email = data.email && /^[A-Za-z0-9._+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/u.test(data.email)
    && !/[\r\n]/u.test(data.email) ? data.email : null
  return <section aria-label="Общие контакты дистрибьютора">
    {data.displayName && <strong>{data.displayName}</strong>}
    {phone && <a href={`tel:${phone.replace(/[ ()-]/gu, '')}`}>{phone}</a>}
    {email && <a href={`mailto:${email}`}>{email}</a>}
    {data.officeAddress && <p>Адрес офиса: {data.officeAddress}</p>}
    {!phone && !email && !data.officeAddress && <p>Дистрибьютор пока не указал общие контакты.</p>}
  </section>
}
